import HelperList from "./helper-list";
import { formatFormikToValidate } from "./helper-object";

export const validateInputDependencies = (
  currentDependencyGroup: any,
  formikValues: any,
  prefixName = ""
): any => {
  if (!currentDependencyGroup || currentDependencyGroup.length === 0) {
    return true;
  }

  const formattedFormikValues = formatFormikToValidate(formikValues);
  const formikKeys = Object.keys(formattedFormikValues);

  const validatedDependencies = currentDependencyGroup.map(
    (dependency: { name: string; value: string | string[] }) => {
      const currentKey = formikKeys.find(
        (key) => key === `${prefixName}${dependency.name}`
      );
      const currentField = currentKey && formattedFormikValues[currentKey];

      const dependencyValueIsAList = Array.isArray(dependency.value);
      if (dependencyValueIsAList) {
        return HelperList.hasSomeEqualValue(currentField, dependency.value);
      }

      return currentField === dependency.value;
    }
  );

  return validatedDependencies.some((v: boolean) => v === true);
};
